/** Consent-aware, tab-scoped acquisition hints. Never stores full URLs or IDs. */
export const ATTRIBUTION_KEY = 'gg_acquisition_v1';
const MAX_AGE = 7 * 86400000;
export type Attribution = { landing: string; referrer: string | null; source: string | null; medium: string | null; campaign: string | null; captured_at: string };
export function campaignTag(value: unknown): string | null {
  return typeof value === 'string' && /^[a-zA-Z0-9_-]{1,64}$/.test(value) ? value : null;
}
export function landingRoute(path: string): string {
  if (/^\/learn\/[a-z0-9-]{1,80}$/.test(path)) return path;
  return ['/', '/learn', '/about', '/auth', '/login', '/pricing'].includes(path) ? path : '/other';
}
export function acquisitionHint(href: string, referrer: string, now = new Date()): Attribution {
  const url = new URL(href);
  let host: string | null = null;
  try {
    const ref = new URL(referrer);
    if (ref.protocol === 'https:' && ref.hostname !== url.hostname && !ref.username && !ref.password) {
      // Only known acquisition hosts. Unknown hosts can contain personal identifiers.
      host = ['google.com','www.google.com','linkedin.com','www.linkedin.com','arenaid.app','gglife.gg','neoaistriq.com'].includes(ref.hostname) ? ref.hostname : 'other';
    }
  } catch { /* No referrer is unknown, never assumed organic/direct. */ }
  return { landing: landingRoute(url.pathname), referrer: host, source: campaignTag(url.searchParams.get('utm_source')), medium: campaignTag(url.searchParams.get('utm_medium')), campaign: campaignTag(url.searchParams.get('utm_campaign')), captured_at: now.toISOString() };
}
export function analyticsAllowed(storage: Pick<Storage, 'getItem'>): boolean {
  try { return JSON.parse(storage.getItem('gg_cookie_consent') || '{}').analytics === true; } catch { return false; }
}
export function readAttribution(storage: Pick<Storage, 'getItem' | 'removeItem'>, now = Date.now()): Attribution | null {
  try {
    const raw = JSON.parse(storage.getItem(ATTRIBUTION_KEY) || 'null');
    const age = now - Date.parse(raw?.captured_at);
    if (!raw || !Number.isFinite(age) || age < 0 || age > MAX_AGE || raw.landing !== landingRoute(raw.landing || '')) { storage.removeItem(ATTRIBUTION_KEY); return null; }
    return { landing: raw.landing, referrer: ['google.com','www.google.com','linkedin.com','www.linkedin.com','arenaid.app','gglife.gg','neoaistriq.com','other'].includes(raw.referrer) ? raw.referrer : null, source: campaignTag(raw.source), medium: campaignTag(raw.medium), campaign: campaignTag(raw.campaign), captured_at: raw.captured_at };
  } catch { return null; }
}

/** Called only when submitting the existing email signup form. No extra fields. */
export function signupAttributionPayload(): { hint: Attribution; analytics_consent: true } | null {
  try {
    if (!analyticsAllowed(localStorage)) return null;
    const hint=readAttribution(sessionStorage);
    return hint ? { hint, analytics_consent: true } : null;
  } catch { return null; }
}
